import { MemsuiteHeaderBlock as MemsuiteHeaderBlockProps } from '@/@types/content';
import { Fragment } from 'react';
import classnames from 'classnames';
import Block from '@/components/cms/Block';
import Text from '@/components/cms/Text';
import Icon from '@/components/ui/Icon';

export interface MemsuiteHeaderProps extends MemsuiteHeaderBlockProps {
  pageName?: string;
}

const MemsuiteHeaderBlock: React.FC<MemsuiteHeaderProps> = ({
  contentLink,
  title,
  titleSecondRow,
  links,
  pageName
}) => {
  const componentTitle = title || pageName;

  const handleOpenInNewTab = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Block
      contentLinkID={contentLink?.id}
      className={classnames('mt-[-161px] bg-black', 'lg:mt-[-98px]')}
      data-component={'MemsuiteHeaderBlockRoot'}
    >
      <div
        className={classnames('container flex flex-col gap-6 pb-6 pt-56', 'lg:pb-10 lg:pt-44')}
        data-component={'MemsuiteHeaderBlock'}
      >
        <h1 className="heading-4">
          {titleSecondRow ? (
            <>
              <Text element="span" className="text-gray">
                {componentTitle}
              </Text>
              <br />
              <Text element="span" className="text-white">
                {titleSecondRow}
              </Text>
            </>
          ) : (
            <Text element="span" className="text-white">
              {componentTitle}
            </Text>
          )}
        </h1>
        <div className="text-2 flex flex-col items-start gap-[8px] font-bold text-white sm:flex-row sm:items-center">
          <div className="flex items-center gap-[4px]">
            <Icon name="users" size="medium" />
            <Text element="span" className="">
              Membership Suite
            </Text>
          </div>
          <Text element="span" className="hidden sm:block">
            •
          </Text>
          {links &&
            links.map((link, index) => {
              return (
                <Fragment key={index}>
                  <button
                    onClick={() => handleOpenInNewTab(link.href as string)}
                    className="flex items-center gap-[4px] hover:text-silver"
                  >
                    <Icon className="sm:hidden" name="" size="medium" />
                    <Text element="span" className="text-2 font-bold">
                      {link.text}
                    </Text>
                    <Icon name="link-out" size="medium" />
                  </button>
                </Fragment>
              );
            })}
        </div>
      </div>
    </Block>
  );
};

export default MemsuiteHeaderBlock;
